<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <TheNotificationsArea v-if="isReadyToDraw" :notifications="notifications" />

    <!-- ログインしてください -->
    <FacePhraseForIndexPage v-if="!isLogin || invalidTokens" phrase="ログインしてください" />

    <!-- BookGroupの一覧 -->
    <TemplateMyTicketsIndex v-else-if="isReadyToDraw" />

    <!-- index画面の描画ローディング -->
    <ItemDialogForIndexPage v-else />
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import TemplateMyTicketsIndex from "@/views/Templates/MyTickets/TemplateMyTicketsIndex";

// API
import API from "@/API";

export default {
  name: "MyTicketsIndex",
  components: {
    TemplateMyTicketsIndex: TemplateMyTicketsIndex,
  },

  setup() {
    const store = useStore();

    const isLogin = store.getters["common/isLogin"];
    // 他端末でログインした場合、tokenはあるが期限切れで未ログインとして扱う必要がある
    // この画面ではリフレッシュトークンを呼ばないので、別途フラグで管理する
    const invalidTokens = ref(false);
    const isReadyToDraw = ref(false);

    const notifications = ref(null)

    onMounted(async () => {
      // リセット
      store.commit("ticketing/setbookGroups", null);
      store.commit("ticketing/setbookGroup", []);
      store.commit("ticketing/setBook", []);
      store.commit("ticketing/setSheet", []);
      store.commit("ticketing/setMasterSheet", []);
      store.commit("ticketing/setPass", []);
      store.commit("ticketing/setMasterPass", []);
      store.commit("ticketing/setIssuedExternalMasterCouponIds", []);

      // index上部に表示する通知を取得
      try {
        notifications.value = (await API.getNotifications()).use_tickets;
      } catch (err) {
        console.log("Error in getNotifications: ", err);
      }

      try {
        await Promise.all([
          // Myチケット取得(未使用)
          API.getMytickets(false, false),
          // Myクーポン取得(isNotRecall: true)
          API.getMyCoupons(true),
        ]);
        isReadyToDraw.value = true;
      } catch (e) {
        // トークン切れの場合エラーが出るので、未ログインの表示を出す
        invalidTokens.value = true;
        isReadyToDraw.value = true;
      }
    });

    return {
      isLogin,
      invalidTokens,
      isReadyToDraw,
      notifications,
    };
  },
};
</script>
